import Api from "~/service/Api";

class CreditAccountRepository {
  fetch(query = {}) {
    return Api.get("/credit-accounts", query);
  }

  update(creditAccountId, data) {
    return Api.post(`/credit-accounts/${creditAccountId}`, data);
  }

  delete(creditAccountId) {
    return Api.delete(`/credit-accounts/${creditAccountId}`);
  }

  create(providerId, data) {
    return Api.post("/credit-accounts", { ...data, providerId });
  }

  createMany(data) {
    return Api.post("/credit-accounts/bulk", data);
  }
}

export default CreditAccountRepository;
